interface IWhatIsIOFText {
  registrationFeeAmount: string
}

export const whatIsIOFText = ({
  registrationFeeAmount,
}: IWhatIsIOFText) => `A Tarifa de análise é um valor cobrado para cobrir os custos relativos ao processamento da sua operação de crédito, incluindo as consultas realizadas junto a agências de referência de crédito e procedimentos antifraude. Estas consultas são indispensáveis para a realização do seu cadastro e seguimento da contratação do curso.
Informações financeiras estarão disponíveis no contrato de financiamento como também os descritivos da taxa de juros, custo efetivo total e ${registrationFeeAmount} de Tarifa de análise.
`
